import { Colors } from "./dsaresult-type";

export const colors: Colors = {
  M: "#1e90ff",
  F: "#ff69b4"
};
